// extracted by mini-css-extract-plugin
export default {"textGradient":"TextGradient_textGradient__Woztm"};